import { render, staticRenderFns } from "./shapeElementOptions.vue?vue&type=template&id=f86dfd00&scoped=true&"
import script from "./shapeElementOptions.vue?vue&type=script&lang=js&"
export * from "./shapeElementOptions.vue?vue&type=script&lang=js&"
import style0 from "./shapeElementOptions.vue?vue&type=style&index=0&id=f86dfd00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86dfd00",
  null
  
)

export default component.exports